import { Api } from "./api"
export * from "./api-res-type"
export default new Api()

